<template>
  <div class="notifications-widget" v-click-outside="onClickOutside">
    <div class="notifications-widget__title">
      <div class="notifications-widget__title-text">Notifications</div>
      <button class="notifications-widget__title-close" @click="closeNotificationsWidget">
        <svg xmlns="http://www.w3.org/2000/svg" width="13" height="14" viewBox="0 0 13 14">
          <path
            fill="#263b3f"
            fill-rule="nonzero"
            d="M6.413 4.855L2.36.333A.938.938 0 0 0 1.635 0c-.28 0-.523.11-.733.333l-.604.673A1.224 1.224 0 0 0 0 1.824c0 .318.1.587.298.809L4.212 7 .298 11.367a1.169 1.169 0 0 0-.298.809c0 .311.1.584.298.818l.604.665a.951.951 0 0 0 .733.341c.29 0 .532-.114.725-.341l4.045-4.514 4.053 4.522c.199.222.44.333.725.333.28 0 .524-.11.733-.333l.604-.673c.199-.234.298-.507.298-.818 0-.318-.1-.587-.298-.809L8.606 7l3.914-4.367c.199-.222.298-.491.298-.809 0-.311-.1-.584-.298-.818l-.604-.665A.951.951 0 0 0 11.183 0a.912.912 0 0 0-.725.341L6.413 4.855z"
          />
        </svg>
      </button>
    </div>
    <div class="notifications-widget__content">
      <notifications-list :limit="5" theme="widget"></notifications-list>
    </div>
  </div>
</template>

<script src="./notifications-widget.js"></script>
<style src="./notifications-widget.scss" lang="scss"></style>
